import { Client } from './ClientTypes';
import { Nullable } from './CommonTypes';

export type CurrentPlanValues = {
    currentValueAmount: number;
    transferValueAmount: number;
    asAtDate: string;
};

export type CurrentPlanProjection = {
    id: number;
    name: string;
    planValue: number;
    isCompleted: boolean;
};

export type CurrentPlanProjectionsPage = {
    scenarioId: number;
    owner: Client;
    projections: CurrentPlanProjection[];
};

export enum GrowthRateBasisType {
    IndustryStandard = 'Industry Standard Growth Rates',
    FundSpecificNominal = 'Fund Specific Growth Rates',
    FundSpecificInflation = 'Inflation Adjusted Fund Specific Rates',
}

export type ProjectedGrowthRateValues = {
    growthRateBasis: GrowthRateBasisType;
    growthRateLow: number | undefined;
    growthRateMid: number | undefined;
    growthRateHigh: number | undefined;
};

export enum FrequencyType {
    Annually = 'Annually',
    Monthly = 'Monthly',
}

export enum EscalationType {
    ZeroPercent = '0%',
    ThreePercent = '3%',
    FivePercent = '5%',
    EightPercent = '8%',
    TenPercent = '10%',
    AEI = 'AEI',
    RPI = 'RPI',
    Other = 'Other',
}

export enum MaturityValuesProjectedEnumType {
    Age = 'To Specific Age',
    Term = 'For Specific Term',
}

export enum PensionStatementDataEntryMethod {
    ProjectedMaturityBasis = 'ProjectedMaturityBasis',
    AssumedChargesAndGrowthRates = 'AssumedChargesAndGrowthRates',
}

export enum ProjectedMaturityBasisType {
    MonetaryProjectionsSupplied = 'Monetary Rates Supplied',
    InflationAdjustedRatesSupplied = 'Inflation Adjusted Rates Supplied',
    UsingProductCharges = 'Calculate Using Product Charges',
    CalculatedUsingAMC = 'Estimated By System',
}

export type OngoingContributionValues = {
    frequency: FrequencyType;
    grossPremium: number;
    escalationType: EscalationType | undefined;
    escalationPercentage: number | undefined;
    increasingEvery: string | undefined;
};

export type ProjectedValuesValues = {
    maturityValuesProjected: MaturityValuesProjectedEnumType;
    retirementAge: Nullable<number> | undefined;
    term: Nullable<number> | undefined;
    pensionStatementDataEntryMethod: PensionStatementDataEntryMethod;
    projectionType: Nullable<ProjectedMaturityBasisType> | undefined;
    lowRateMaturityValue: Nullable<number> | undefined;
    midRateMaturityValue: Nullable<number> | undefined;
    highRateMaturityValue: Nullable<number> | undefined;
    calculationMethod: Nullable<string> | undefined;
    amc: Nullable<number> | undefined;
    fundCharge: Nullable<number> | undefined;
    planCharge: Nullable<number> | undefined;
    policyFee: Nullable<number> | undefined;
    advisorCharge: Nullable<number> | undefined;
};
